<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout column align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card v-if="updateProfile" class="elevation-2">
            <v-form @submit.prevent="updateProfile">
              <v-toolbar color="primary">
                <v-toolbar-title>Profile</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
<!--              error bar-->
              <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-layout>
              <v-card-text v-if="user!==null">
                <v-list>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>person</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-text-field
                          v-model="user.name"
                          label="Business Name"
                          required
                          outlined
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="title font-weight-light">
                      {{user.email}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :disabled="loading || user.name == ''" :loading="loading">
                  Update
                <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-actions>
            </v-form>
            <v-card-text v-if="userData">
              <div class="headline mb-3">Brand logos</div>

              <v-divider></v-divider>
              <div class="subtitle-1">Thumbnail</div>
              <v-img
                  v-if="!userData.thumbnailMediaUrl"
                  contain
                  @click="uploadThumbnailImage"
                  src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FPayment%20Methods.png?alt=media&token=b85863d5-fdb7-42c5-be8b-dec9a5418594"
                  width="200px"
              ></v-img>
              <v-img

                  contain
                  @click="uploadThumbnailImage"
                  :src="userData.thumbnailMediaUrl"
                  width="200px"
              ></v-img>

              <v-divider></v-divider>
              <div class="subtitle-1">Header</div>
              <v-img
                  v-if="!userData.headerMediaUrl"
                  @click="uploadHeaderImage()"
                  contain
                  src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FPayment%20Methods.png?alt=media&token=b85863d5-fdb7-42c5-be8b-dec9a5418594"
                  width="300px"
              ></v-img>
              <v-img
                  v-if="userData.headerMediaUrl"
                  contain
                  @click="uploadHeaderImage()"
                  :src="userData.headerMediaUrl"
                  width="200px"
              ></v-img>

            </v-card-text>
          </v-card>
        </v-flex>
        <v-dialog v-model="imageUploadDialog"
                  ref="dialog"
                  persistent
                  width="500px"
        >
          <v-card>
            <v-card-title v-if="editThumbnailImage">Upload Thumbnail Image</v-card-title>
            <v-card-title v-if="editHeaderImage">Upload Header Image</v-card-title>
            <gen-img-uploader :path="path" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
            <v-card-text v-if="mediaUrl">
              <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text :disabled="!mediaUrl"  @click="updateProfile">ok</v-btn>
              <v-btn text @click="cancelImageUpload">cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import {deleteObject, getStorage, ref} from "firebase/storage";
import {doc, onSnapshot} from "firebase/firestore";

export default {
  data: () => ({
    path: 'userContent',
    email: '',
    password: '',
    signUp: false,
    name: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    editHeaderImage: false,
    editThumbnailImage: false,
    imageUploadDialog: false,
    mediaUrl: false,
    imgId: null,
    userData: null
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    this.editHeaderImage = false
    this.editThumbnailImage = false
    let db = this.$store.state.db
    // fetches transactions associated by this number
    let userRef = doc(db, 'users', this.user.uid)
    onSnapshot(userRef, res => {
      if (res.exists) {
        // console.log(res.data())
        this.userData = res.data()
      }
      this.$store.dispatch('setLoading', false)
    })
  },
  methods: {
    updateProfile () {
      this.$store.dispatch('updateUserProfile', this.userData)
      this.imageUploadDialog = false
      this.editHeaderImage = false
      this.editThumbnailImage = false
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    uploadHeaderImage () {
      this.editHeaderImage = true
      this.imageUploadDialog = true
    },
    uploadThumbnailImage () {
      this.editThumbnailImage = true
      this.imageUploadDialog = true
    },
    addImageLink (value) {
      this.mediaUrl = value.url
      this.imgId = value.id
      if (this.editThumbnailImage) {
        this.userData.thumbnailMediaUrl = value.url
      }
      if (this.editHeaderImage) {
        this.userData.headerMediaUrl = value.url
      }
    },
    cancelImageUpload () {
      this.imageUploadDialog = false
      this.mediaUrl = undefined
      this.editHeaderImage = false
      this.editThumbnailImage = false
      this.deleteUploadedImage()
    },
    deleteUploadedImage () {
      if (this.imgId != null) {
        let userId = this.user.uid
        let storage = getStorage()
        let imgRef = ref(storage, '/users/' + userId + '/' + this.path + '/' + this.imgId)
        deleteObject(imgRef)
            .then (() => {
              this.imgId = null
            })
            .catch((err) => {
              this.$store.dispatch('setError', err)
            });
      }

    },
    removeImageLink () {
      this.mediaUrl = undefined
      this.editHeaderImage = false
      this.editThumbnailImage = false
    }
  }

}
</script>

